import { useMemo, useState } from 'react';
import MojitoModules from 'mojito/modules';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';

const { Button, FlexPane, Image, Text } = MojitoPresentation.Components;
const { CountryOrSportIcon } = MojitoModules;
const { useContainerItems } = MojitoModules.Common.Hooks;
const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;
const { SortingHelper } = MojitoPresentation.Utils;
const SportUtils = MojitoServices.SportsContent.Sports.utils;

const SportCountriesList = props => {
    const {
        groupId,
        onNavigate,
        sportId,
        mojitoTools: { appContext, config, stringResolver },
    } = props;
    const { routeResolver } = appContext;
    const language = appContext.systemSettings().language;
    const countries = useContainerItems(groupId);
    const [expandedCountryId, setExpandedCountryId] = useState();

    const sortedCountries = useMemo(
        () =>
            [...(countries || [])].sort((a, b) => SortingHelper.compare(a.name, b.name, language)),
        [countries, language]
    );

    if (!sortedCountries.length) {
        return null;
    }

    return (
        <FlexPane config={config.container} class="ta-SportCountriesList">
            <FlexPane config={config.headerContainer}>
                <Text config={config.headerText}>
                    {stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.COUNTRIES_AZ_TITLE')}
                </Text>
            </FlexPane>
            {sortedCountries.map(country => {
                const expanded = expandedCountryId === country.id;
                return (
                    <FlexPane key={country.id} config={config.countryContainer}>
                        <Button
                            config={config.countryHeader}
                            onClick={() =>
                                setExpandedCountryId(current =>
                                    current === country.id ? undefined : country.id
                                )
                            }
                            active={expanded}
                            class="ta-sportCountryHeader"
                        >
                            <FlexPane config={config.countryIdentity}>
                                <CountryOrSportIcon
                                    sportId={sportId}
                                    countryCode={country.countryCode}
                                    countryName={country.countryName}
                                    config={config.countryOrSportIcon}
                                />
                                <Text config={config.countryName}>{country.name}</Text>
                            </FlexPane>
                            <Image config={expanded ? config.collapseIcon : config.expandIcon} />
                        </Button>
                        {expanded && (
                            <FlexPane
                                config={config.leaguesContainer}
                                class="ta-sportCountryLeagues"
                            >
                                {(country.items || []).map(league => {
                                    const isRacing = SportUtils.isRacingSport(sportId);
                                    const leagueRoute = isRacing
                                        ? NavigationPathBuilder.toFutureRaceEvent(
                                              sportId,
                                              league.id
                                          )
                                        : NavigationPathBuilder.toSportCompetitionsLeague(
                                              sportId,
                                              league.id
                                          );
                                    const onLeagueClick = () => {
                                        if (isRacing) {
                                            IntentActionTrigger.showFutureRaceEventPage(
                                                sportId,
                                                league.id
                                            );
                                        } else {
                                            IntentActionTrigger.showSportCompetitions(
                                                sportId,
                                                league.id
                                            );
                                        }
                                        onNavigate();
                                    };
                                    return (
                                        <Button
                                            key={league.id}
                                            config={config.leagueButton}
                                            onClick={onLeagueClick}
                                            hrefLink={routeResolver.getRoute(leagueRoute)}
                                            class="ta-sportCountryLeague"
                                        >
                                            <Text config={config.leagueName}>{league.name}</Text>
                                            <Image config={config.leagueIcon} />
                                        </Button>
                                    );
                                })}
                            </FlexPane>
                        )}
                    </FlexPane>
                );
            })}
        </FlexPane>
    );
};

export default SportCountriesList;
